<template>
  <v-app :style="{ background: $vuetify.theme.themes.dark.background }">
    <topBar />
    <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
    <v-container>
      <v-row align="center" justify="center">
        <v-col cols="12" md="10">
          <v-card>
            <v-card-title>
              <h1>Sobre Nosotros</h1>
            </v-card-title>
            <v-card-text>
              <p>
                ¡Bienvenido a HM Reformas! Somos más que una empresa de
                reformas en Tarazona; somos tu socio confiable en la
                transformación de espacios. Con más de 15 años de experiencia,
                hemos perfeccionado el arte de la construcción y la renovación
                para ofrecerte soluciones excepcionales.
              </p>

              <p>
                En HM Reformas, entendemos que cada proyecto es único.
                Nuestro equipo de expertos, con más de una década y media en el
                sector, está comprometido a dar vida a tus ideas. Desde obras
                nuevas hasta la rehabilitación de viviendas, ofrecemos servicios
                integrales respaldados por un conocimiento profundo y una
                experiencia sólida.
              </p>

              <p>
                Nos destacamos en diversas áreas, incluyendo electricidad,
                fontanería, aire acondicionado e instalaciones fotovoltaicas.
                Nuestro compromiso es superar tus expectativas en cada proyecto.
                Utilizamos materiales de la más alta calidad y aplicamos las
                últimas técnicas y tecnologías para garantizar resultados
                excepcionales.
              </p>

              <p>
                ¿Tienes en mente una nueva obra, una reforma o cualquier proyecto
                de construcción? ¡Contáctanos hoy mismo! Estamos aquí para
                asesorarte y ofrecerte la solución perfecta para tus necesidades.
                En HM Reformas, no solo construimos estructuras,
                creamos experiencias.
              </p>

              <p>
                ¡Gracias por considerar a HM Reformas para tu próximo
                proyecto! Estamos emocionados de trabajar contigo y hacer realidad
                tus visiones arquitectónicas.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
          <v-col cols="12" sm="10">
            <cardPresentationVue />
          </v-col>
          <v-col cols="12" sm="10">
            <v-card>
              <v-card-title>
                Opiniones de nuestros clientes
              </v-card-title>
              <customerFeddbac />
            </v-card>
           
           
          </v-col>
          <v-col cols="12" sm="10">
            <formulario />
          </v-col>
        </v-row>
    </v-container>
    <sideAlert class="floating-button" />
    <contactVue class="floating-contact" />

    <a
            :href="'https://www.facebook.com/profile.php?id=61555855631904&locale=es_ES'"
            target="_blank"
          >
            <v-icon color="teal" class="floating-facebook">mdi-facebook</v-icon>
          </a>
          <a
            :href="'https://www.instagram.com/hernanmorareformas/'"
            target="_blank"
          >
            <v-icon color="red" class="floating-instagram">mdi-instagram</v-icon>
          </a>

  </v-app>
</template>

<script>
import topBar from "@/components/topBar.vue";
import sideAlert from "@/components/sideAlert.vue";
import formulario from "@/components/form.vue";
import cardPresentationVue from "@/components/cardPresentation.vue";
import carrusel from "@/components/carrusel.vue";
import contactVue from "@/components/contact.vue";
import customerFeddbac from "@/components/customerFeddbac.vue";

export default {
  name: "App",

  data() {
    return {
      alertInfo: {
        title: "¡Emergencias 24h 7 dias a la semana!",
        message:
          "Si tienes alguna emergencia de electricidad, fontanería o pequeña avería en tu hogar",
        phone: "617 870 811",
      },
    };
  },

  components: {
    topBar,
    sideAlert,
    formulario,
    cardPresentationVue,
    carrusel,
    contactVue,
    customerFeddbac,
  },
};
</script>

<style scoped>
.mt-4 {
  margin-top: 50%; 
}
.floating-button {
  position: fixed;
  bottom: 55%; 
  right: 20px; 
}
.floating-contact{
  position: fixed;
  bottom: 45%;
  right: 20px;
}
.floating-facebook{
  position: fixed;
  bottom: 35%;
  right: 20px;
}
.floating-instagram{
  position: fixed;
  bottom: 30%;
  right: 20px;
}
</style>
